import React, { useState, FunctionComponent, ReactNode } from 'react';
import { widgetDataContext } from './widgetDataContext';
import { useDidUpdate } from '@lt/components/hooks';

type Props = {
  children: ReactNode;
  /** базовое состояние для виджета, удобно для отладки */
  initialState?: unknown;
};

/** провайдер для передачи данные получаемых из api в виджеты */
export const WidgetDataContextProvider: FunctionComponent<Props> = ({ children, initialState }) => {
  const [data, setData] = useState<undefined | unknown>(initialState);

  useDidUpdate(() => {
    setData((prevData: undefined | any) => {
      return {
        ...(prevData || {}),
        ...((initialState as any) || {}),
      };
    });
  }, [initialState]);

  return (
    <widgetDataContext.Provider
      value={{
        data,
        setData,
      }}
    >
      {children}
    </widgetDataContext.Provider>
  );
};
